<template>
	<div class="pie-chart">
		<chart-base :chart-options="options" :height="height" :width="width"></chart-base>
	</div>
</template>

<script>
import chartMixin from './chartMixin.js'

export default {
	name: 'PieChart',
	mixins: [chartMixin],
	computed: {
		options() {
			const baseConfig = {
				title: {
					text: '',
					left: 'center',
					top: '39%',
					show: true,
					textStyle: {
						fontSize: 18,
						fontWeight: 'bold',
						color: 'rgba(0,0,0,0.9)',
					},
				},
				color: [
					'rgba(0, 62, 197, 1)',
					'rgba(0, 62, 197, 0.75)',
					'rgba(0, 62, 197, 0.5)',
					'rgba(0, 62, 197, 0.25)',
					'rgba(0, 62, 197, 0.1)',
				],
				legend: {
					bottom: 0,
					left: 'center',
					itemWidth: 12,
					itemHeight: 12,
					icon: 'circle',
					data: [],
					orient: 'horizontal',
				},
				series: [
					{
						type: 'pie',
						radius: ['32%', '56%'],
						center: ['50%', '45%'],
						avoidLabelOverlap: false,
						itemStyle: {
							borderRadius: 4,
							borderColor: '#fff',
							borderWidth: 4,
						},
						label: {
							position: 'outer',
							alignTo: 'edge',
							show: true,
							fontSize: 10,
							lineHeight: 16,
							formatter: '{b}\n{c|{c}}',
							edgeDistance: 0,
							rich: {
								c: {
									fontSize: 12,
									fontWeight: 'bold',
								},
							},
						},
						labelLine: {
							smooth: 1,
							length: 15,
							length2: 170,
						},
						emphasis: {
							disabled: true,
						},
						data: this.data,
					},
				],
			}

			const mergedOptions = this.mergeOptions(baseConfig, this.chartOptions)
			const data = mergedOptions.series[0].data

			if (mergedOptions.legend.data.length === 0) {
				mergedOptions.legend.data = data.map(item => item.name)
			}

			const sum = data.reduce((acc, cur) => acc + cur.value, 0)
			mergedOptions.title.text = `${sum}`

			return mergedOptions
		},
	},
}
</script>

<style lang="scss" scoped>
.pie-chart {
	width: 100%;
	height: 100%;
	padding: 0 3%;
}
</style>
